import { IProfileFormFieldConfig } from '../details/personalInfo/personalInfo.interface';
import { IAddressFieldConfig } from '../details/addresses/address/address.interface';
import { SupportedLanguage } from '../config/constants/supportedLanguage.enum';

export default class SortHelpers {
    public static sortProfileFieldAscendingOrder(
        fieldConfigA: IProfileFormFieldConfig,
        fieldConfigB: IProfileFormFieldConfig,
    ): number {
        return fieldConfigA.order - fieldConfigB.order;
    }

    public static sortAddressFieldAscendingOrder(
        fieldConfigA: IAddressFieldConfig,
        fieldConfigB: IAddressFieldConfig,
        local: SupportedLanguage,
    ) {
        return fieldConfigA.order[local] - fieldConfigB.order[local];
    }
}
